require('canvas-confetti/dist/confetti.browser');

class Confetti {
    constructor(colors, duration) {
        this.colors = colors || ['#bb0000', '#ffffff'];
        this.duration = duration || 5;
        this.render();
    }

    render() {
        let self = this;
        let timer = setInterval(function () {
            confetti({
                particleCount: 2,
                angle: 60,
                spread: 55,
                origin: {x: 0},
                colors: self.colors
            });
            confetti({
                particleCount: 2,
                angle: 120,
                spread: 55,
                origin: {x: 1},
                colors: self.colors
            });
        }, 10);

        setTimeout(function () {
            clearInterval(timer);
        }, this.duration * 1000);
    }
}

export default Confetti;
